import { render, staticRenderFns } from "./MeetingsCalendar.vue?vue&type=template&id=2c1bdf65&"
import script from "./MeetingsCalendar.vue?vue&type=script&lang=js&"
export * from "./MeetingsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports